import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-select-company',
  templateUrl: './select-company.component.html'
})
export class SelectCompanyComponent implements OnInit {
  @Output()
  formReady = new EventEmitter<FormGroup>();

  @Input() companyId: any;

  form = this.fb.group({
    idCompany: ['', [Validators.required]],
    insCompany: ['', [Validators.required]],
    companyAddress: ['', [Validators.required]],
  });

  companies: any;

  constructor(private fb: FormBuilder, private authService: AuthenticationService) { }

  ngOnInit() {
    this.formReady.emit(this.form);
    this.getCompanies();
  }

  getCompanies(){
    this.authService.getCompanies().then((res:any)=>{
      this.companies = res.filter((x:any) => x.isLoan == true);
      console.log(this.companyId);
      if(this.companyId){
        let val = {target: {value: this.companyId}}
        this.updateCompany(val);
      }
    }, err=>{
      console.log(err);
    })
  }

  updateCompany(data:any){
    console.log(data.target.value);
    let selectedCompany = this.companies.find((x:any) => x.id == data.target.value);
    let address = selectedCompany.address1;
    if(selectedCompany.address2){
      address += ', ' + selectedCompany.address2
    }
    address += ', ' + selectedCompany.city + ' '+ selectedCompany.state + ' ' + selectedCompany.zip;

    this.form.patchValue({
      idCompany: selectedCompany.id,
      insCompany: selectedCompany.name,
      companyAddress: address
    });
  }

}
